// Local string hero ids → OpenDota numeric ids.
// Generated from https://api.opendota.com/api/heroes
// Moved verbatim out of components/DraftBoard.js (Phase 2.1 of unify).
const HERO_ID_MAP = {
  'abaddon': 102,
  'abyssal_underlord': 108,
  'alchemist': 73,
  'ancient_apparition': 68,
  'antimage': 1,
  'arc_warden': 113,
  'axe': 2,
  'bane': 3,
  'batrider': 65,
  'beastmaster': 38,
  'bloodseeker': 4,
  'bounty_hunter': 62,
  'brewmaster': 78,
  'bristleback': 99,
  'broodmother': 61,
  'centaur': 96,
  'chaos_knight': 81,
  'chen': 66,
  'clinkz': 56,
  'crystal_maiden': 5,
  'dark_seer': 55,
  'dark_willow': 119,
  'dawnbreaker': 135,
  'dazzle': 50,
  'death_prophet': 43,
  'disruptor': 87,
  'doom_bringer': 69,
  'doom': 69, // Alias
  'dragon_knight': 49,
  'drow_ranger': 6,
  'earth_spirit': 107,
  'earthshaker': 7,
  'elder_titan': 103,
  'ember_spirit': 106,
  'enchantress': 58,
  'enigma': 33,
  'faceless_void': 41,
  'furion': 53, // Nature's Prophet
  'nature_prophet': 53, // Alias
  'grimstroke': 121,
  'gyrocopter': 72,
  'hoodwink': 123,
  'huskar': 59,
  'invoker': 74,
  'jakiro': 64,
  'juggernaut': 8,
  'keeper_of_the_light': 90,
  'kez': 145,
  'kunkka': 23,
  'legion_commander': 104,
  'leshrac': 52,
  'lich': 31,
  'life_stealer': 54,
  'lifestealer': 54, // Alias
  'lina': 25,
  'lion': 26,
  'lone_druid': 80,
  'luna': 48,
  'lycan': 77,
  'magnataur': 97,
  'magnus': 97, // Alias
  'marci': 136,
  'mars': 129,
  'medusa': 94,
  'meepo': 82,
  'mirana': 9,
  'monkey_king': 114,
  'morphling': 10,
  'muerta': 138,
  'naga_siren': 89,
  'necrolyte': 36,
  'necrophos': 36, // Alias
  'nevermore': 11, // Shadow Fiend
  'shadow_fiend': 11, // Alias
  'night_stalker': 60,
  'nyx_assassin': 88,
  'obsidian_destroyer': 76,
  'outworld_destroyer': 76, // Alias
  'ogre_magi': 84,
  'omniknight': 57,
  'oracle': 111,
  'pangolier': 120,
  'phantom_assassin': 44,
  'phantom_lancer': 12,
  'phoenix': 110,
  'primal_beast': 137,
  'puck': 13,
  'pudge': 14,
  'pugna': 45,
  'queenofpain': 39,
  'queen_of_pain': 39, // Alias
  'rattletrap': 51, // Clockwerk
  'clockwerk': 51, // Alias
  'razor': 15,
  'riki': 32,
  'ringmaster': 131,
  'rubick': 86,
  'sand_king': 16,
  'shadow_demon': 79,
  'shadow_shaman': 27,
  'shredder': 98, // Timbersaw
  'timbersaw': 98, // Alias
  'silencer': 75,
  'skeleton_king': 42, // Wraith King
  'wraith_king': 42, // Alias
  'skywrath_mage': 101,
  'slardar': 28,
  'slark': 93,
  'snapfire': 128,
  'sniper': 35,
  'spectre': 67,
  'spirit_breaker': 71,
  'storm_spirit': 17,
  'sven': 18,
  'techies': 105,
  'templar_assassin': 46,
  'terrorblade': 109,
  'tidehunter': 29,
  'tinker': 34,
  'tiny': 19,
  'treant': 83,
  'treant_protector': 83, // Alias
  'troll_warlord': 95,
  'tusk': 100,
  'undying': 85,
  'underlord': 108, // Alias
  'ursa': 70,
  'vengefulspirit': 20,
  'vengeful_spirit': 20, // Alias
  'venomancer': 40,
  'viper': 47,
  'visage': 92,
  'void_spirit': 126,
  'warlock': 37,
  'weaver': 63,
  'windrunner': 21, // Windranger
  'windranger': 21, // Alias
  'winter_wyvern': 112,
  'wisp': 91, // Io
  'io': 91, // Alias
  'witch_doctor': 30,
  'zuus': 22, // Zeus
  'zeus': 22, // Alias
};

export default HERO_ID_MAP;
